<template>
    <div v-show="searchColList && searchColList.length > 0" 
        class="cg-advanced-search-warp">

        <template v-if="MultipleConditions">

            <a-card size="small">
                <template slot="title">
                    <a-button size="small" type="link" icon="plus" @click="AddCondition">添加条件</a-button>
                </template>
                <template slot="extra">
                    <a-button size="small" type="link" icon="close" @click="MultipleConditions=false"></a-button>
                </template>

                <div v-for="(item, index) in ConditionList" :key="item.Key" style="margin-bottom: 5px;">
                    <SearchCondition ref="SearchCondition" :search-col-list="SearchColList" @search="OnSearch"></SearchCondition>
                    <a-button style="float: right;" v-if="ConditionList.length > 1" type="link" @click="DelCondition(item)">删除</a-button>
                </div>
    
                <a-button block icon="search" @click="OnSearch">搜索</a-button>
            </a-card>
        </template>

        <template v-else>
            <!-- <a-checkbox v-model="FindInResults">
                结果中查找
            </a-checkbox> -->
            <a-checkbox v-model="MultipleConditions">
                多条件查找
            </a-checkbox>
            <!--搜索条件-->
            <SearchCondition ref="SearchCondition" :searchColList="SearchColList" @search="OnSearch"></SearchCondition>
            <!--搜索按钮-->
            <a-button icon="search" @click="OnSearch" />
        </template>
    </div>
</template>
<script>
import SearchCondition from "./SearchCondition.vue";

export default {
    components: {
        SearchCondition
    },
    props:{
        searchColList: {
            type: Array,
            default: []
        }
    },
    data() {

        return {
            FindInResults: false, //在结果集中查找
            MultipleConditions: false, //多条件查找
            ConditionList: [{ Key:  "key_" + new Date().getTime() }]
        }
    },
    computed: {
        SearchColList() {
            
            if(this.MultipleConditions && this.searchColList.length > 1) {
                return this.searchColList.slice(1, this.searchColList.length);
            }

            return this.searchColList;
        }
    },
    watch: {
        MultipleConditions() {

            if(this.MultipleConditions) {

                let _condition = this.$refs.SearchCondition.GetCondtion();

                if(_condition.SelectedCol.indexOf("/") < 0) {
                    this.ConditionList.length = 1;

                    this.$nextTick(()=>{
                        this.$refs.SearchCondition[0].SetCondtion(_condition);
                    });
                }
            }
            else {

                this.$nextTick(()=>{
                    this.OnSearch();
                });
            }
        }
    },
    methods: {
        //增加搜索条件
        AddCondition() {
            this.ConditionList.push({ Key: "key_" + new Date().getTime() });
        },
        //删除搜索条件
        DelCondition(condition) {

            let _index = this.ConditionList.findIndex(item => item.Key == condition.Key);

            if(_index >= 0) {
                this.ConditionList.splice(_index, 1);
            }
        },
        OnSearch() {

            if(this.MultipleConditions) {
                
                let _conditionList = (this.$refs.SearchCondition || []).map((item)=>{
                    return item.GetCondtion();
                });

                this.$emit("search", {
                    FindInResults: this.FindInResults,
                    MultipleConditions: this.MultipleConditions,
                    ConditionList: _conditionList
                });
            }
            else {

                let _condition = this.$refs.SearchCondition.GetCondtion();

                this.$emit("search", Object.assign(_condition, {
                    FindInResults: this.FindInResults,
                    MultipleConditions: this.MultipleConditions
                }));
            }
        }
    }
}
</script>
<style>
.cg-advanced-search-warp .ant-table-thead{
    display: none;
}
.cg-advanced-search-warp .ant-table-body{
    margin: 0 !important;
}
.cg-advanced-search-warp .search-condition-row td {
    padding: 0px !important;
}
</style>